export default function numberForString(string) {
  if (!string) return null;
  return Number(string);
}
